<template>
    <div class="sc-content">
        <div class="bkklists">
            <div v-for="(val, index) in list" :key="index" :class="{'hidden-device' : isHiddenDevice(index), 'col col-xs-6 col-md-4': isRelated}" class="item">
                <div class="bkklist">
                    <div class="image">
                        <a :href="val.url">
                            <img v-lazy="val.thumbnail" :data-srcset="val.thumbnailx2 + ' 2x'" :srcset="val.thumbnailx2 + ' 2x'" :alt="val.title" />
                        </a>
                        <div class="share-wrap">
                            <div class="block">
                                <a href="#" v-if="isLogin && following( val.id )" @click="toggleFollow( val.id )" class="following btn btn-sm btn-follow">Following</a>
                                <a href="#" v-if="isLogin && !following( val.id )" @click="toggleFollow( val.id )" class="btn btn-sm btn-follow">Follow</a>
                                <div class="share-lists">
                                    <a class="list" href="#" @click="fbURLShare(val.url);"><i class="ic ic-facebook"></i></a>
                                    <a class="list" href="#" @click="tweetURLShare(val.url);"><i class="ic ic-twitter"></i></a>
                                    <a class="list device" href="#" @click="lineURLMSG(val.url);"><i class="ic ic-line-app"></i></a>
                                    <a class="list" href="#" @click="copytoclipboard(this, val.url);"><i class="ic ic-link"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="meta">
                        <h3 class="title"><a :href="val.url">{{ val.title }}</a></h3>
                        <div class="info">
                            <div class="category"><a :href="val.group_url"><strong>{{ val.group_name }}</strong></a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import jQuery from 'jquery'
import config from '@/../myconfig.js'
/* Import Jquery Plugins */

import VueLazyload from 'vue-lazyload'

window.jQuery = window.$ = jQuery

/* Import Jquery Plugins */
// require('@/assets/theme/bkkmenu-2017/assets/js/fixto/fixto.min.js')
Vue.use(VueLazyload)

const myConfig = config
let followIds = []

export default {
  name: 'BkklistHome',
  mounted () {
    this.isLogin = false
    this.isOverview = (location.pathname.indexOf('/overview') > -1)
    this.isRelated = (location.pathname.indexOf('/overview') == -1 && location.pathname.indexOf('/bkklist/') > -1)

    fetch(myConfig.API_PATH + 'bkklist/get_following').then(res => {
      return res.json()
    }).then(data => {
      followIds = data.response
    })
  },
  data: function () {
    return {
      list: window._bkklist,
      THEME_PATH: myConfig.THEME_PATH,
      isLogin: Boolean,
      isOverview: Boolean,
      isRelated: Boolean
    }
  },
  methods: {
    isHiddenDevice (index) {
      if (!this.isOverview && index == 4) {
        return true
      } else if (this.isRelated && index == 2) {
        return true
      } else {
        return false
      }
    },

    following (id) {
      id = parseInt(id)
      return followIds.indexOf(id) > -1
    },

    toggleFollow (id) {
      id = parseInt(id)

      if (followIds.indexOf(id) > -1) {
        followIds.splice(followIds.indexOf(id), 1)
      } else {
        followIds.push(id)
      }

      this.$http.post(myConfig.API_PATH + 'bkklist/')
    },

    fbURLShare (u, title = '') {
      var g = {
        u: u,
        title: (title != '' ? title : document.title)
      }
      var a = addQS('https://www.facebook.com/sharer.php', g)

      window.open(a, 'sharer', 'toolbar=0,status=0,width=626,height=436')
      return false
    },

    tweetURLShare (u) {
      var g = {
        url: u,
        text: document.title + ' - '
      }
      var a = addQS('http://twitter.com/share', g)

      window.open(a, 'tweet', 'toolbar=0,status=0,width=626,height=436')
      return false
    },

    lineURLMSG (u) {
      window.location = 'line://msg/text/' + encodeURIComponent(u)
    },

    copytoclipboard (currentObj, value) {
      $('body').append('<input type="text" id="__tempCopy" style="position: fixed; top:-1000; left: -1000;" value="' + value + '">')
      $('#__tempCopy').focus().select()

      var msg = document.execCommand('copy')
      if (msg) {
        $('#clipboard').fadeIn(300)
        setTimeout(function () {
          $('#clipboard').fadeOut(300)
        }, 1500)
      }

      return false
    }
  }
}
</script>
